import React from 'react';
import { ReactComponent as Mood } from '../../images/Icons/moodStroke5.svg';
import { navIconStyle } from "../../css/globalStyles";

export default function MoodIcon(props) {

  return (
    <Mood style={{ ...props.medalStyle, ...navIconStyle.svgSizeList }} />
  );
}